import { render, staticRenderFns } from "./EnnaLayout.vue?vue&type=template&id=0158f831"
import script from "./EnnaLayout.vue?vue&type=script&lang=js"
export * from "./EnnaLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports